import React, { useState, useCallback } from 'react';
import Topbar from './Topbar';
import Header from './Header';
import MobileMenu from './MobileMenu';
import Footer from './Footer';
import SearchOverlay from '../common/SearchOverlay';

const Layout = ({ children, transparentHeader = false }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setMobileMenuOpen((prev) => {
      const next = !prev;
      document.body.style.overflow = next ? 'hidden' : '';
      document.documentElement.style.overflow = next ? 'hidden' : '';
      return next;
    });
  }, []);

  const closeMenu = useCallback(() => {
    setMobileMenuOpen(false);
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }, []);

  const openSearch = useCallback(() => {
    setSearchOpen(true);
    // Close mobile menu if open
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  }, [mobileMenuOpen]);

  const closeSearch = useCallback(() => {
    setSearchOpen(false);
  }, []);

  return (
    <>
      <a href="#main-content" className="skip-link">
        Vai al contenuto principale
      </a>
      <Topbar />
      <Header
        transparent={transparentHeader}
        onHamburgerClick={toggleMenu}
        menuOpen={mobileMenuOpen}
        onSearchClick={openSearch}
      />

      <MobileMenu isOpen={mobileMenuOpen} onClose={closeMenu} />
      <SearchOverlay isOpen={searchOpen} onClose={closeSearch} />

      <main id="main-content">{children}</main>

      <Footer />
    </>
  );
};

export default Layout;
